import React from 'react'
import IncludeSideBar from '../../Components/Sidebar/IncludeSideBar'


function PrivacyPolicy() {
  return (
    <IncludeSideBar>
        <div>
            <p>
                Here we are displaying the Privacy Policy details.
            </p>
        </div>
    </IncludeSideBar>
  )
}

export default PrivacyPolicy